var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m27.17 14.459-8.683 11.4a1.9 1.9 0 0 1-1.501.741 1.899 1.899 0 0 1-1.501-.722l-4.636-5.909a1.9 1.9 0 0 1 .332-2.67 1.902 1.902 0 0 1 2.67.333l3.097 3.952 7.182-9.5a1.912 1.912 0 1 1 3.04 2.318v.057Z",
  fill: "currentColor"
})));
export default SvgCheckmark;